import LocalDateFilter from 'edge/platform/time/LocalDateFilter';
import 'gw-portals-viewmodel-angular';
import JSInteropAscpect from './_JSInteropAspect';

export default angular.module('edge.platform.time', ['gw-portals-viewmodel-angular']).filter('gwLocalDate', LocalDateFilter).run(['ViewModelService', function (ViewModelService) {
    ViewModelService.addAspectFactory(JSInteropAscpect);
}]);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/time/module.js
// module id = 1082
// module chunks = 0